// @ts-nocheck
import {FC, useEffect} from "react";
import PS from "@/services/permission/permission-service";
import * as Enums from "@/utils/enums";
import Helper from "@/utils/helper";
import Router from "next/router";
import {Box, Space} from "@mantine/core";
import WhatsNewConfig from "@/PageComponents/Admin/WhatsNewConfig";
import MessageBarConfig from "@/PageComponents/Admin/MessageBarConfig";
import InitialSetupConfig from "@/PageComponents/Admin/InitialSetupConfig";
import { createFileRoute } from '@tanstack/react-router'




const _userAdmin = PS.hasPermission(Enums.PermissionName.MasterSystemAdmin);


const AdminPage: FC = () => {


    useEffect(() => {
        if(!_userAdmin) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, []);

    return <>
        <Box mih={'calc(100dvh - 80px)'}>

            <Space  h={30}/>
            {/*<Box px={'sm'}>
                <h1>Admin Page</h1>
            </Box>*/}

            {/* whats is removed since the feedbear update <WhatsNewConfig />*/}
            {/*<Space h={20} />*/}

            <MessageBarConfig />
            <Space h={20} />
            <InitialSetupConfig />

        </Box>
    </>
}

export default AdminPage;

export const Route = createFileRoute('/_authenticated/admin')({ component: AdminPage })
